import '../../css/blocks/latestnewsgrid.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const latestnewsgridBlocks = document.querySelectorAll('.latestnewsgrid');
  
  if (latestnewsgridBlocks.length) {
    // Initialize block-specific functionality here
  }
});
